import { clsx, type ClassValue } from 'clsx'
import dayjs from 'dayjs'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// FHIR requires seconds and an offset once a time is present; milliseconds are optional
const FHIR_DATE_TIME =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/

export function formatFhirDatetime(date: string) {
  if (/^\d{4}$/.test(date)) return dayjs(date, 'YYYY').format('YYYY')

  if (/^\d{4}-\d{2}$/.test(date))
    return dayjs(date, 'YYYY-MM').format('MMM YYYY')

  if (FHIR_DATE_TIME.test(date)) return dayjs(date).format('D MMM YYYY, h:mm a')

  return dayjs(date, 'YYYY-MM-DD').format('D MMM YYYY')
}
